import {Injectable} from '@angular/core';
import {RegisafeGlobalDataObject} from '../../interfaces/interfaces.regisafe';
import {MessagesService} from '../messages/messages.service';
import {APP_MESSAGES} from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class SharedDataService {

	regisafeGlobalData: RegisafeGlobalDataObject = {
		orgastruktur: 'Aktenplanverwaltung',
		title: 'Aktenzeichen',
		iconname: 'folder',
		iconcolor: '#DD969B'
	};

	staticOrgastructureValues = [
		{
			icon: 'folder',
			color: '#DD969B',
			iconInactiv: 'folder-outline',
		},
		{
			icon: 'folder-open',
			color: '#92C9B3',
			iconInactiv: 'folder-open-outline',
		},
		{
			icon: 'document-text',
			color: '#F2E88E',
			iconInactiv: 'document-text-outline',
		},
		{
			icon: 'people',
			color: '#708FA0',
			iconInactiv: 'people-outline',
		},
		{
			icon: 'mail',
			color: '#74C2C6',
			iconInactiv: 'mail-outline',
		},
		{
			icon: 'albums',
			color: '#CCCCCC',
			iconInactiv: 'albums-outline',
		}
	];

	staticIconValues = {
		Aktenplanverwaltung: {
			icon: 'folder',
			color: '#DD969B',
			iconInactiv: 'folder-outline',
		},
		VorgangsVerwaltung: {
			icon: 'folder-open',
			color: '#92C9B3',
			iconInactiv: 'folder-open-outline',
		},
		Schriftgutverwaltung: {
			icon: 'document-text',
			color: '#F2E88E',
			iconInactiv: 'document-text-outline',
		},
		Sitzungsverwaltung: {
			icon: 'people',
			color: '#708FA0',
			iconInactiv: 'people-outline',
		},
		Adressverwaltung: {
			icon: 'mail',
			color: '#74C2C6',
			iconInactiv: 'mail-outline',
		},
		default: {
			icon: 'albums',
			color: '#CCCCCC',
			iconInactiv: 'albums-outline',
		}
	}

	constructor(private msgService: MessagesService) {

	}

	public getRegisafeGlobalData(): RegisafeGlobalDataObject {
		return this.regisafeGlobalData;
	}

	public setRegisafeGlobalData(data: RegisafeGlobalDataObject, origin?: string) {
		this.regisafeGlobalData.orgastruktur = data.orgastruktur;
		this.regisafeGlobalData.iconname = data.iconname;
		this.regisafeGlobalData.iconcolor = data.iconcolor;
		this.regisafeGlobalData.title = data.title;

		this.msgService.sendMessage({context: APP_MESSAGES.globalDataChanged, changed: true});
	}
}
